import React, { Component } from 'react'
import { connect } from 'react-redux'
import BookingInput from '../Booking/bookinginput';
import { apiInstance } from '../../actions/http';
import { applyCoupon, openModal } from '../../actions';
import ButtonLoader from '../btnloader';

class CheckCoupon extends Component {

    state = {
        value: '',
        err: '',
        fetching: false
    };

    handleCoupon = async () => {
        if(!this.props.user.token){
            this.props.dispatch(openModal("LOG_IN"));
            return; 
        }
        let { value } = this.state;
        this.setState({fetching: true});
        try {
            let res = await apiInstance({
                url: `offer/${value}/validate_offer/`,
                method: 'get',
                headers: {
                    Authorization: `Token ${this.props.user.token}`
                }
            });
            if(res){
                this.setState({fetching: false})
                this.props.dispatch(applyCoupon(res.data));
            }
        } catch(err) {
            this.setState({err: 'Invalid Coupon', fetching: false})
        }
    }

    render() {
        return (
            <div className="row m-t-10 m-b-10">
                <BookingInput 
                    placeholder="Enter coupon code"
                    size={9}
                    value={this.state.value}
                    onChange={(e) => this.setState({value: e.target.value, err: ''})}
                    err={this.state.err}
                />
                <div className="col-md-3 p-0">
                    <button 
                        className="btn btn-ouja btn-block" 
                        style={{height: `38px`, marginTop: `2px`}} 
                        onClick={this.handleCoupon}
                        disabled={!this.state.fetching && this.state.value ? false: true}
                    >
                        {this.state.fetching ? <ButtonLoader /> : 'Apply Coupon'}
                    </button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.loginReducer.data
})

const CheckCouponInput = connect(mapStateToProps)(CheckCoupon)

export default CheckCouponInput
